<p-button
  [type]="actionType()"
  [disabled]="disabled()"
  [label]="label()"
  [severity]="severity()"
  [variant]="variant()"
  [rounded]="rounded()"
  [size]="size()"
  [loading]="loading()"
  (onClick)="onClick($event)"
  [styleClass]="buttonClass()"
>
</p-button>
